import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchJournalPage } from '../../ducks/journalCards.duck';

const RELATED_SECTION_ID = 'detail-journal-related-cards';

export const loadData = (params, search) => (dispatch, getState) => {
  const pageId = params.pageId;
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;

  return dispatch(fetchPageAssets(pageAsset, hasFallbackContent)).then(() => {
    const sections = getState().hostedAssets?.pageAssetsData?.[pageId]?.data?.sections || [];
    const needsJournalCards = sections.some(section => section.sectionId === RELATED_SECTION_ID);
    if (!needsJournalCards) {
      return null;
    }
    return dispatch(fetchJournalPage());
  });
};
